import { container } from '../../ioc/container';
import { Services } from '../../ioc/services';
import type { IMonitoring } from './IMonitoring';

/**
 * Decorator that wraps a method with transaction monitoring
 * @param transactionName The name of the transaction to monitor
 * @returns A decorator function
 */
export function monitored(transactionName: string) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = async function (...args: any[]) {
      const monitoring = container.get<IMonitoring>(Services.Monitoring);
      const transaction = monitoring.transaction(transactionName);

      return transaction.execute(() => originalMethod.apply(this, args));
    };

    return descriptor;
  };
}
